import { twMerge } from "tailwind-merge";
import { HTMLAttributes, forwardRef } from "react";

export interface TooltipProps extends HTMLAttributes<HTMLDivElement> {}

const Tooltip = forwardRef<HTMLDivElement, TooltipProps>((props, ref) => {
  const { className, ...rest } = props;

  return (
    <div
      {...rest}
      ref={ref}
      className={twMerge(
        "max-w-xs w-fit py-1 px-2 text-white bg-black rounded-md",
        className
      )}
    />
  );
});

export default Tooltip;
